import { render } from "./component_imageSelector.vue?vue&type=template&id=6f19836f"
import script from "./component_imageSelector.vue?vue&type=script&lang=js"
export * from "./component_imageSelector.vue?vue&type=script&lang=js"

import "./component_imageSelector.vue?vue&type=style&index=0&id=6f19836f&lang=css"

import exportComponent from "/Users/patrikhubner/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__